var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 53,
    viewBox: "0 0 39 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.3227C38 31.1583 36.3322 29.876 32.7588 29.876H25.1352C25.1352 29.876 23.3086 30.1163 24.1822 28.1125C25.0558 26.1086 29.5822 16.2491 24.8971 14.1651C24.8971 14.1651 21.5394 12.812 20.6882 17.8525C19.4968 24.9064 14.1763 28.273 11 32.7617V48.5527C11 48.5527 12.6678 51.9994 18.7823 51.9994H30.297C30.297 51.9994 33.4737 52.1596 32.9972 47.3501C32.9972 47.3501 37.2061 46.4684 34.5853 42.0598C34.5853 42.0598 39.2707 41.0178 35.856 36.4487C35.856 36.4487 38 35.4868 38 33.3224V33.3227Z",
    stroke: "#0A6E5F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16658 31H9.83342C10.4772 31 11 31.492 11 32.0979V49.9021C11 50.508 10.4772 51 9.83342 51H2.16658C1.52276 51 1 50.508 1 49.9021V32.0979C1 31.492 1.52276 31 2.16658 31Z",
    stroke: "#0A6E5F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5447 8.78785L12 6.18268",
    stroke: "#0A6E5F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7229 7.07516L24.1699 1",
    stroke: "#0A6E5F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9999 9.77239L35.2289 7.0803",
    stroke: "#0A6E5F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumsUp);
export default __webpack_public_path__ + "static/media/thums_up.df649c34265bab7d9aeaff0c6e7e3133.svg";
export { ForwardRef as ReactComponent };